module.exports = __webpack_public_path__ + "static/img/pay_qrpay_close@3x.0ac10f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pay_qrpay_close@3x.png
// module id = neji
// module chunks = 1